import { render, staticRenderFns } from "./IngressTarget.vue?vue&type=template&id=0a90a212&scoped=true&"
import script from "./IngressTarget.vue?vue&type=script&lang=js&"
export * from "./IngressTarget.vue?vue&type=script&lang=js&"
import style0 from "./IngressTarget.vue?vue&type=style&index=0&id=0a90a212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90a212",
  null
  
)

export default component.exports